import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router/index";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import ko from "element-plus/es/locale/lang/ko";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import "@/assets/main.scss";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

const store = createPinia();
store.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(router);
app.use(ElementPlus, {
  locale: ko,
});
app.use(store);
app.mount("#app");
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
